import React from 'react';
import classNames from 'classnames';
import ImageWithPlaceholder from '@profile/src/Components/ImageWithPlaceHolder';
import Spinner from '@profile/src/Components/Spinner';
import { CosmeticStatus } from '@profile/src/utils/types';
import { webImageUri } from '@profile/src/utils/uri';
import styles from './styles.module.scss';

const CosmeticTab = ({
  className,
  onChangeCosmetic,
  chosenId,
  cosmeticConfigs
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.avatarList, className)
  }, cosmeticConfigs && cosmeticConfigs.map(item => (item === null || item === void 0 ? void 0 : item.cosmeticInfo.status) !== CosmeticStatus.SELLING && (item === null || item === void 0 ? void 0 : item.cosmeticInfo.status) !== CosmeticStatus.PREPARE_SELLING && /*#__PURE__*/React.createElement("div", {
    key: item === null || item === void 0 ? void 0 : item.id,
    className: styles.avatarDiv
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: `avatar-${item === null || item === void 0 ? void 0 : item.id}`,
    name: "avatarList",
    checked: (item === null || item === void 0 ? void 0 : item.id) === chosenId,
    onChange: () => onChangeCosmetic(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.urlImage)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.checkBox
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: `avatar-${item === null || item === void 0 ? void 0 : item.id}`,
    className: styles.avatarLabel
  }, (item === null || item === void 0 ? void 0 : item.urlImage) && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portrait,
    src: webImageUri(item.urlImage),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: 100,
      className: styles.portrait
    })
  })))));
};

export default CosmeticTab;